module.exports = jsdom;


//////////////////
// WEBPACK FOOTER
// external "jsdom"
// module id = M4QQ
// module chunks = 71c9